import DOMPurify from 'dompurify';

export const sanitizeHtml = data => DOMPurify.sanitize(data);

export const isValidSearchInput = str => str.length >= 3 || str === '';
